import {Button, Stack, Typography} from "@mui/material";
import MicrosoftAuthenticatorDialog from "../dialogs/MicrosoftAuthenticatorDialog";
import * as React from "react";
import {useState} from "react";
import GoogleAuthenticatorDialog from "../dialogs/GoogleAuthenticatorDialog";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "i18nano";
import {LoadingButton} from "@mui/lab";
import {ApiService} from "../api/ApiService";
import {useAuthStore} from "../stores/authStore";
import {useNotification} from "../stores/notificationStore";

interface DownloadAuthenticatorComponentProps {
    onClick: () => void;
}

const DownloadAuthenticatorComponent: React.FC<DownloadAuthenticatorComponentProps> = ({onClick}) => {
    const authStore = useAuthStore();
    const [microsoftAuthenticatorDialog, setMicrosoftAuthenticatorDialog] = useState(false);
    const [googleAuthenticatorDialog, setGoogleAuthenticatorDialog] = useState(false);
    const t = useTranslation();
    const navigate = useNavigate();
    const notification = useNotification();

    const [loading, setLoading] = useState(false)

    const skipAuthenticator = async () => {
        setLoading(true);
        if (!authStore.login || !authStore.password) return;
        const response = await ApiService.AuthenticatorSkip(authStore.login, authStore.password);
        if (response.success) {
            navigate("/phoneAuthenticator");
        } else {
            notification.open(response.errors[0], "error");
        }
        setLoading(false);
    }

    return (
        <>
            <Stack spacing={2}
                   justifyContent={'center'}
            >

                <Typography variant="h4" align={'center'}>
                    {t("Download")} Authenticator
                </Typography>
                <Typography variant="body1" gutterBottom align={"center"}>
                    {t("Install one of the following programs to your mobile device")}
                </Typography>
                <Stack direction={"row"} spacing={1}>
                    <Stack spacing={1} style={{width: 200}} alignItems={"center"}>
                        <div style={{height: 120, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                            <img style={{width: 120}} alt={"Microsoft Authenticator"}
                                 src={"https://play-lh.googleusercontent.com/_1CV99jklLbXuun-6E7eCPR-sKKeZc602rhw_QHZz-qm7xrPdgWsJVc7NtFkkliI8No=w240-h480-rw"}/>
                        </div>
                        <Typography variant="subtitle2" align={'center'}>
                            Microsoft Authenticator
                        </Typography>
                        <Button variant="outlined" fullWidth
                                onClick={() => setMicrosoftAuthenticatorDialog(true)}>
                            {t("Download")}
                        </Button>
                    </Stack>
                    <Stack spacing={1} style={{width: 200}} alignItems={"center"}>
                        <div style={{height: 120, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                            <img style={{width: 100}} alt={"Microsoft Authenticator"}
                                 src={"data:image/png;base64,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"}/>
                        </div>
                        <Typography variant="subtitle2" align={'center'}>
                            Google Authenticator
                        </Typography>
                        <Button variant="outlined" fullWidth onClick={() => setGoogleAuthenticatorDialog(true)}>
                            {t("Download")}
                        </Button>
                    </Stack>
                </Stack>

                <Button size={"large"} variant="contained" onClick={onClick}>{t("Next")}</Button>
                <LoadingButton style={{marginTop: 10}} variant="outlined" size={"large"}
                               onClick={skipAuthenticator} loading={loading}
                               fullWidth>{t("Skip")}
                </LoadingButton>
                {/*<NavLink to={"/phoneAuthenticator"}
                         style={{display: "block", width: "100%", textAlign: "center", marginTop: "10px"}}>
                    {t("Use phone number instead")}
                </NavLink>*/}
            </Stack>
            <MicrosoftAuthenticatorDialog
                open={microsoftAuthenticatorDialog}
                onClose={() => setMicrosoftAuthenticatorDialog(false)}/>
            <GoogleAuthenticatorDialog
                open={googleAuthenticatorDialog}
                onClose={() => setGoogleAuthenticatorDialog(false)}/>
        </>
    )

}
export default DownloadAuthenticatorComponent;